import { AfterViewInit, Component, DestroyRef, inject, OnDestroy, OnInit } from '@angular/core';
// import { MemberService } from 'src/app/services/core/member/member.service';
import { NUMBER_OF_RECORDS } from 'src/app/utils/common.utils';
import { LosService } from 'src/app/services/core/levelOfService/los.service';
import { debounceTime, filter, forkJoin, Subject} from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { SharedDataService } from 'src/app/services/app/shared-service/shared-data.service';
import * as moment from 'moment-timezone';
import { timeZone } from 'src/app/utils/utils.common';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { FundingSourceService } from 'src/app/services/core/funding-source/funding-source.service';
import { PermissionService } from 'src/app/services/app/permission-access-service/permissionBased.service';
import { UserPermission } from 'src/app/enums/enums';
import { MemberService } from 'src/app/services/core/member/member.service';
import { StagingTripService } from 'src/app/services/core/distributions/staging-trip/staging-trip.service';

@UntilDestroy()
@Component({
    selector: 'app-staging-trip',
  templateUrl: './staging-trip.component.html',
  styleUrls: ['./staging-trip.component.css']
})
export class StagingTripComponent implements OnInit, OnDestroy, AfterViewInit {
  selectedTrips: any = [];
  search: any = '';
  trips: any = [];
  fundingSources: any;
  preLevelOfService:any = {};
  currentPage = 1;
  totalResults = 0;
  totalPages = 0;
  numberOfRecords = NUMBER_OF_RECORDS
  todayDate:any = [];
  memberNotesObj: any;
  user: any;
  preFundingSource:any = {};
  timeZone:any = timeZone;
  currentDate:any = moment().tz(this.timeZone).toISOString()
  filterdataList:any= [];
  members:any = [];
  selectedMembers: any = '';
  memberSearchQuery: any;
  memberPageNumber = 1;
  memberSearchPageNumber = 1;
  private searchSubject = new Subject<string>();

  constructor(
    private sharedDataService: SharedDataService,
    private levelOfService : LosService,
    private stagingTripService:StagingTripService,
    private router: Router,
    private fundingSourceService: FundingSourceService,
    public permissionService: PermissionService,
    private memberService: MemberService,
    private route: ActivatedRoute
  ) {

  }
  ngAfterViewInit(): void {
  }

  ngOnInit(): void {
    this.getUser();
    this.getFundingSources()
    this.getAllMembers();
    this.initializeSearch();
  }


  getUser() {
    this.sharedDataService.getUser().pipe(untilDestroyed(this)).subscribe((data) => {
      if (data) {
        this.user = data;
        if (this.user.timeZone) {
          this.timeZone = this.user.timeZone;
        }
        this.todayDate = [
          moment().tz(this.timeZone).startOf("day"),
          moment().tz(this.timeZone).endOf("day"),
        ];
        this.loadInitialData();
      }

    })
  }

  loadInitialData() {
    const queryparams = {
      limit: 9999,
      isActive: 'true'
    }
    forkJoin({
      levelOfService: this.levelOfService.getPicker(queryparams),
    }).pipe(untilDestroyed(this))
      .subscribe(({ levelOfService}: any) => {
  
        //  Level of Service
        if (levelOfService?.results?.length) {
          this.preLevelOfService = levelOfService.results.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
        }

        //  Trips 
        this.getAllTrips(this.currentPage);
      });
  }

  getAllTrips(page: any) {
    this.clear();
    let queryparams :any= {
      limit: 50,
      page,
      // status: this.selectedStatus,
      time: [this.todayDate[0].toISOString(), this.todayDate[1].toISOString()],
      // company: this.selectedCompany || undefined,
      sortBy: 'pickup.time:asc',

    }
  
    if (this.search) {
      const trimmedSearch = this.search.trim();
      queryparams.search = trimmedSearch;
    }
 
    this.stagingTripService.getAllTrips(queryparams).pipe(untilDestroyed(this))
      .subscribe((data: any) => {
        if (data && data.results) {
            this.trips = data.results;
          this.filterdataList = this.trips;
          this.totalPages = data.totalPages;
          this.totalResults = data.totalResults;
        }
      })
  }

  getPageCount() {
    const length = this.filterdataList.length;
    const count = (50 * this.currentPage) - (length !== 50 ? (50 - length) : 0);
    return `${count} of ${this.totalResults}`;
  }

  onPageChange(page: number) {
    this.currentPage = page;
    this.getAllTrips(this.currentPage);

  }

  onDateChange(event: any) {
    this.todayDate = [
      event[0],
      event[1].endOf("day"),
    ];
     this.currentPage = 1;
    this.getAllTrips(this.currentPage);
  }


  clear(){
    this.trips = []
    this.selectedTrips = []
    // this.trip.isSelected = false;
  }

  getAllMembers() {
    const queryParams: any = {
      limit: 10,
      page: this.memberPageNumber,
      isActive: true,

    }
    this.memberService.getPickerMembers(queryParams).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data && data.results) {
        this.members = [...this.members, ...data.results];
        this.memberPageNumber += 1;
      }
    })
  }

  getFundingSources() {
    const queryParams = {
      limit: 9999,
      isActive: true
    }
    this.fundingSourceService
      .getPicker(queryParams)
      .pipe(untilDestroyed(this)).subscribe((data: any) => {
        if (data && data.results) {
          this.fundingSources = data.results;
          this.preFundingSource = this.fundingSources.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
        }
      });
  }

  ngOnDestroy(): void {
  }

 initializeSearch() {
  this.searchSubject
    .pipe(
      debounceTime(500), // wait for typing to stop
      filter(search => !search || search.length >= 3)  // only trigger if >=3 chars OR empty (to reset search)
    ).subscribe(() => {
      this.currentPage = 1;
      this.getAllTrips(this.currentPage);
    });
  }

  onSearchInput() {
    this.searchSubject.next(this.search);
  }
  breakString(str: any) {
    if (!str) return "";
    return str.replace(/\n/g, "<br>");
  }

  openNotesModal(memberNotes: any) {
    this.memberNotesObj = memberNotes;
  }
  
  createTrip(trip: any) {
    this.router.navigate(['/trips/new'], { queryParams: { stagingTripId: trip.id } });
  }

}
